module.exports = __webpack_public_path__ + "img/mobile-fr.c281f33f.png";